import { defineMessages } from 'react-intl';

export default defineMessages({
  goToHomePage: {
    id: 'view.appBar.ariaLabel.goToHomePage',
    defaultMessage: 'Go to home page',
  },
  selectSeller: {
    id: 'view.header.selectSeller',
    defaultMessage: 'Select seller',
  },
  language: {
    id: 'view.header.languageLabel',
    defaultMessage: 'Language',
  },
  darkMode: {
    id: 'view.header.darkmode',
    defaultMessage: 'Dark mode',
  },
  lightMode: {
    id: 'view.header.lightmode',
    defaultMessage: 'Light mode',
  },
  logout: {
    id: 'view.header.logout',
    defaultMessage: 'Log out',
  },
});
